import { render } from "./recovery_form.vue?vue&type=template&id=e18da610"
import script from "./recovery_form.js?vue&type=script&lang=js&external"
export * from "./recovery_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__